import styled from 'styled-components';

export const AboutSubscriptionStyled = styled.div`
  margin-top: 7px;
  width: 100%;
  max-width: 275px;
`;
